import { render, staticRenderFns } from "./Profit.vue?vue&type=template&id=0be75dee&scoped=true"
import script from "./Profit.js?vue&type=script&lang=js&external"
export * from "./Profit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be75dee",
  null
  
)

export default component.exports